<template>
  <v-app class="tw-w-full tw-relative tw-overflow-hidden">
    <div
      class="tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0 tw-bg-cover tw-scale-150"
      :style="{
        'background-image': `url(${
          album && album['images']
            ? album['images'][0]['url']
            : music.post_image
        })`
      }"
      style="filter:blur(16px); transform: scale(1.5);"
    ></div>
    <div class="tw-w-full tw-my-0 tw-mx-auto tw-relative md:tw-py-16" id="smartBox">
      <div class="tw-w-full md:tw-rounded-2xl tw-overflow-hidden">
        <div
          class="tw-w-full tw-flex tw-flex-col tw-items-center tw-text-white"
          style="background-color: #4f1087;"
        >
          <div style="text-align: center; margin: 32px 0;">
            <h2 class="tw-text-2xl tw-font-extrabold tw-font-sans tw-m-0">
              {{ music ? music.albumTitle : album.album["name"] }}
            </h2>
            <span
              class="tw-text-sm tw-font-light tw-font-sans"
              v-if="album && album['artists'].length"
            >
              <span v-for="(artist, index) in album['artists']" :key="index">
                {{ artist["name"]
                }}<span
                  v-if="
                    artist['id'] !==
                      album['artists'][album['artists'].length - 1]['id']
                  "
                  >,</span
                >
              </span>
            </span>
            <span
              class="tw-text-sm tw-font-light tw-font-sans"
              v-else
            >
              <span v-if="mp_album">
                <!-- código anterior
                {{ artista.artista_nome }} -->
                <span v-for="(holder, index) in albumData.mainArtist">
                  {{ holder.Name || holder.name }}
                  <span v-if="index !== albumData.mainArtist.length - 1"
                    >|
                  </span>
                </span>
              </span>
              <span v-else>
                {{ listHoldings() }}
              </span>
            </span>
          </div>
          <div
            class="tw-w-4/5 tw-mx-auto tw-shadow-md tw-rounded-t-lg"
            v-if="!album && music ? !!music.presaveOptions : false"
            v-html="getEmbedUrl(music.presaveOptions.youtube_url)"
          ></div>
          <img
            class="tw-w-4/5 tw-mx-auto tw-shadow-md tw-rounded-t-lg"
            v-else
            :src="mp_album ? albumData.post_image : music.post_image"
          />
        </div>
        <div
          class="tw-w-full tw-flex tw-flex-col tw-items-center tw-text-black tw-bg-white"
          style=""
        >
          <div
            class="tw-w-4/5 tw-flex tw-justify-around tw-items-center tw-mx-auto tw-rounded-b-lg tw-border tw-border-black tw-border-opacity-20 tw-overflow-hidden tw-shadow-md"
          >
            <a
              style="display: flex;"
              @click="copyUrl()"
              class="tw-text-gray-600 tw-text-sm sm:tw-text-md tw-font-sans tw-w-6/12 tw-justify-center tw-py-3"
              v-ripple
              ><img class="tw-w-5 tw-mr-1" src="/imgs/copy.png" />
              <span class="font tw-my-auto">Copiar URL</span>
            </a>
            <a
              style="display: flex;"
              @click="dialog = true"
              class="tw-text-gray-600 tw-text-sm sm:tw-text-md tw-font-sans  tw-w-6/12  tw-justify-center tw-py-3"
              v-ripple
              ><img class="tw-w-5 tw-mr-1 tw-shrink-0" src="/imgs/share.png" />
              <span class="font tw-my-auto">Compartilhar</span>
            </a>
          </div>
          <div
            class="tw-w-full tw-flex tw-h-24"
            style="border-bottom: 2px solid lightgrey; vertical-align: center;"
            v-for="(link, index) in links"
            v-if="canLinkShow(link.type) && link.is_active == true"
          >
            <div
              class="tw-w-full tw-flex tw-justify-between tw-items-center tw-text-center tw-px-4"
            >
              <img
                :src="platforms[link.type].img"
                style="height: 35px;"
                alt=""
                v-if="platforms[link.type]"
              />
              <span
                class="tw-font-bold tw-font-sans tw-text-purple-400 tw-uppercase"
                v-else
                >{{ link.link_text }}</span
              >
              <a
                class="tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-sans"
                v-ripple
                v-if="album"
                style="color: #4f1087; width: 180px; padding: 12px; border-radius: 8px; box-shadow: 1px 0 5px rgba(0,0,0,0.5);"
                target="_blank"
                :href="`/s/link/${link.id}`"
              >
                <img
                  style="width: 24px; margin-right: 12px;"
                  src="/imgs/play.png"
                />PLAY
              </a>
              <a
                @click.prevent="
                  confirmDialog = true;
                  selectedPresave = link.type;
                "
                class="tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-sans"
                v-ripple
                v-if="!album && presave[link.type]"
                style="color: #4f1087; width: 180px; padding: 12px; border-radius: 8px; box-shadow: 1px 0 5px rgba(0,0,0,0.5);"
              >
                <img
                  style="width: 24px; margin-right: 12px;"
                  src="/imgs/play.png"
                />PRÉ-SAVE
              </a>
            </div>
          </div>
          <div
            class="tw-w-full tw-flex tw-h-24"
            style="border-bottom: 2px solid lightgrey; vertical-align: center;"
            v-for="(props, type) in platforms"
            v-if="!album && presave[type]"
          >
            <div
              class="tw-w-full tw-flex tw-justify-between tw-items-center tw-text-center tw-px-4"
            >
              <img :src="props.img" style="height: 35px;" alt="" />
              <a
                @click.prevent="
                  confirmDialog = true;
                  selectedPresave = type;
                "
                class="tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-sans"
                v-ripple
                v-if="!album && presave[type]"
                style="color: #4f1087; width: 180px; padding: 12px; border-radius: 8px; box-shadow: 1px 0 5px rgba(0,0,0,0.5);"
              >
                <img
                  style="width: 24px; margin-right: 12px;"
                  src="/imgs/play.png"
                />PRÉ-SAVE
              </a>
            </div>
          </div>
          <div class="tw-font-sans tw-pt-16 tw-pb-8" v-if="!links && !music">
            Esse lan�amento ainda n�o possui links dispon�veis
          </div>
          <iframe
            v-if="youtube_id"
            style="width: 100%; height: 260px; margin-top: 40px;"
            :src="`https://www.youtube.com/embed/${youtube_id}`"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <div class="tw-py-6 tw-px-8 xs:tw-px-12">
            <div class="tw-flex tw-justify-center" v-if="backstage">
              <div
                class="tw-mr-4 tw-rounded-full tw-border-4 tw-border-purple-700 tw-overflow-hidden tw-my-10"
              >
                <img
                  :src="artista.post_image"
                  class="tw-h-32 tw-w-32 tw-object-cover"
                  alt=""
                />
              </div>
              <div class="tw-flex tw-flex-col tw-justify-center">
                <p
                  class="tw-font-sans tw-font-extrabold tw-text-purple-700 tw-text-2xl sm:tw-text-3xl tw-mb-2"
                >
                  {{ artista.artista_nome }}
                </p>
                <a
                  v-ripple
                  target="_blank"
                  class="tw-flex tw-justify-center tw-items-center tw-w-40 tw-h-10 tw-font-sans tw-font-bold tw-text-purple-700 tw-text-md sm:tw-text-lg tw-px-3 tw-tracking-wide tw-border-2 tw-border-purple-700 tw-rounded-xl tw-leading-5"
                  :href="`/artist/${artista.artista_url}/backstage`"
                >
                  <span>BACKSTAGE</span
                  ><img
                    class="tw-ml-3 tw-w-2.5 tw-h-4"
                    src="/imgs/chevron_right.png"
                  />
                </a>
              </div>
            </div>
            <div
              v-if="
                smartsite
                  ? smartsite.domain_name
                    ? true
                    : !!smartsite.websiteUrl
                  : false
              "
              class="tw-mb-16"
            >
              <a
                v-ripple
                class="tw-flex tw-py-4 tw-px-6 sm:tw-px-12 tw-rounded-3xl tw-text-white tw-text-xl tw-font-sans tw-font-bold tw-items-center tw-justify-center"
                style="background-color: #4f1087"
                target="_balnk"
                :href="
                  smartsite.domain_name
                    ? 'https://' + smartsite.domain_name
                    : smartsite.websiteUrl
                "
              >
                <img class="tw-w-8 tw-mr-3" src="/imgs/globe.png" /><span
                  class="tw-text-md sm:tw-text-lg"
                  >WEBSITE</span
                >
              </a>
            </div>
            <div class="tw-mx-auto">
              <img class="tw-w-2/5 tw-mx-auto" src="/imgs/musicpro-logo.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar v-model="snackbar" top :timeout="2000">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false"
          >Fechar</v-btn
        >
      </template>
    </v-snackbar>
    <v-dialog
      v-model="confirmDialog"
      max-width="450"
      transition="scroll-y-transition"
    >
      <v-card>
        <v-toolbar dark class="tw-bg-purple-600">
          <v-btn icon dark small class="tw-ml-1" @click="confirmDialog = false">
            <v-icon class="tw-text-sm">fas fa-times</v-icon>
          </v-btn>
          <v-toolbar-title class="tw-font-sans tw-pl-2"
            >Confirmar</v-toolbar-title
          >
        </v-toolbar>
        <div class="tw-px-2 tw-py-4">
          <div class="tw-px-2">
            Ao fazer o pré-save você concorda que iremos salvar seu email, e ter
            permissões de criar, editar e seguir playlists para avisar você na
            dia do lançamento.
            <div class="tw-pt-5 tw-text-right">
              <v-btn dark @click="confirmDialog = false">Cancelar</v-btn>
              <v-btn dark class="tw-bg-purple-600" @click="popup()"
                >Confirmar e Continuar</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="450" transition="scroll-y-transition">
      <v-card>
        <v-toolbar dark class="tw-bg-purple-600">
          <v-btn icon dark small class="tw-ml-1" @click="dialog = false">
            <v-icon class="tw-text-sm">fas fa-times</v-icon>
          </v-btn>
          <v-toolbar-title class="tw-font-sans tw-pl-2"
            >Compartilhar</v-toolbar-title
          >
        </v-toolbar>
        <div class="tw-px-2 tw-py-4">
          <div class="tw-px-2">
            <div class="tw-flex tw-items-center tw-flex-wrap tw--mx-2">
              <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                <v-btn
                  target="_blank"
                  :href="shareLinks['facebook']"
                  block
                  dark
                  outlined
                  class="tw-font-sans tw-text-xs tw-relative tw-mb-3"
                >
                  <v-icon
                    right
                    dark
                    class="tw-text-sm tw-absolute tw-left-0 tw--ml-1"
                    >fab fa-facebook</v-icon
                  >
                  Facebook
                </v-btn>
              </div>
              <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                <v-btn
                  target="_blank"
                  :href="shareLinks['twitter']"
                  block
                  dark
                  outlined
                  class="tw-font-sans tw-text-xs tw-relative tw-mb-3"
                >
                  <v-icon
                    right
                    dark
                    class="tw-text-sm tw-absolute tw-left-0 tw--ml-1"
                    >fab fa-twitter</v-icon
                  >
                  Twitter
                </v-btn>
              </div>
              <div class="tw-w-full tw-px-2">
                <v-btn
                  target="_blank"
                  :href="shareLinks['whatsapp']"
                  block
                  dark
                  outlined
                  class="tw-font-sans tw-text-xs tw-relative tw-mb-3 md:tw-mb-0"
                >
                  <v-icon
                    right
                    dark
                    class="tw-text-sm tw-absolute tw-left-0 tw--ml-1"
                    >fab fa-whatsapp</v-icon
                  >
                  Whatsapp
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Layout from "@/Shared/NoMenu";
import EventBus from "@/eventbus.js";
import { Head } from "@inertiajs/inertia-vue";

export default {
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  metaInfo() {
    return {
      title: "MusicPro - SmartLink"
    };
  },
  props: [
    "custom_links",
    "platforms",
    "links",
    "provider",
    "shareLinks",
    "mp_album",
    "album",
    "albumData",
    "holdings",
    "music",
    "youtube_id",
    "artista",
    "backstage",
    "smartsite",
    "upc",
    "spotifyAuth",
    "deezerToken",
    "me",
    "error",
    "isrc",
    "appleToken",
    "redirectUri",
    "redirectUriDeezer"
  ],
  components: { Head },
  data() {
    return {
      confirmDialog: false,
      message: "",
      snackbar: false,
      selectedPresave: "",
      dialog: false,
      scopes: ["user-read-email", "playlist-modify-public"],
      clientId: "e51a8800913345e592ce4a73ccc0eebb",
      clientSecret: "712adba3c45d4669bc81178f9f4a90b4",
      instanceApple: "",
      presave: {
        spotify: () => {
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          const isAndroid = /Android/i.test(navigator.userAgent);
          const encodedUpc = btoa(this.upc); // Codifica o UPC em base64
          
          // Armazena UPC na sessão como fallback para casos de cancelamento
          axios.post('/api/store-presave-context', {
            upc: this.upc,
            provider: 'spotify'
          }).then(() => {
            const authUrl = "https://accounts.spotify.com/authorize?client_id=" +
              this.clientId +
              "&response_type=code&redirect_uri=" +
              encodeURIComponent(this.redirectUri) +
              "&scope=user-read-email,playlist-modify-public" +
              "&state=" + encodedUpc;
            
            if (isMobile) {
              let deepLinkUrl;
              
              if (isAndroid) {
                // Android - usa intent:// scheme com fallback URL
                deepLinkUrl = "intent://accounts.spotify.com/inapp-authorize?client_id=" +
                  this.clientId +
                  "&response_type=code&redirect_uri=" +
                  encodeURIComponent(this.redirectUri) +
                  "&scope=user-read-email,playlist-modify-public" +
                  "&state=" + encodedUpc +
                  "#Intent;scheme=https;package=com.spotify.music;end";
              } else {
                // iOS - usa spotify-action:// scheme
                deepLinkUrl = "spotify-action://authorize?client_id=" +
                  this.clientId +
                  "&response_type=code&redirect_uri=" +
                  encodeURIComponent(this.redirectUri) +
                  "&scope=user-read-email,playlist-modify-public" +
                  "&state=" + encodedUpc;
              }
              
              let hasAppOpened = false;
              
              // Detecta se o usuário saiu da página (app abriu)
              const onBlur = () => {
                hasAppOpened = true;
                window.removeEventListener('blur', onBlur);
              };
              
              window.addEventListener('blur', onBlur);
              
              // Timeout para fallback
              const timeout = setTimeout(() => {
                window.removeEventListener('blur', onBlur);
                if (!hasAppOpened) {
                  window.open(authUrl, "_self");
                }
              }, 2000);
              
              // Tenta abrir o deep link
              window.location.href = deepLinkUrl;
              
              // Cleanup após um tempo
              setTimeout(() => {
                clearTimeout(timeout);
                window.removeEventListener('blur', onBlur);
              }, 3000);
            } else {
              // Desktop - usa a URL normal
              window.open(authUrl, "_self");
            }
          }).catch(() => {
            // Se falhar ao armazenar na sessão, continua mesmo assim
            const authUrl = "https://accounts.spotify.com/authorize?client_id=" +
              this.clientId +
              "&response_type=code&redirect_uri=" +
              encodeURIComponent(this.redirectUri) +
              "&scope=user-read-email,playlist-modify-public" +
              "&state=" + encodedUpc;
            
            window.open(authUrl, "_self");
          });
        },
        deezer: () =>
          window.open(
            "https://connect.deezer.com/oauth/auth.php?app_id=541242&redirect_uri=" +
              this.redirectUriDeezer +
              "&perms=basic_access,email,manage_library,offline_access",
            "_self"
          ),
        appleMusic: async () => {
          let authorized = await this.instanceApple.authorize();
          const vm = this;
          const res = await axios.post("/api/create/smartlink", {
            accessToken: authorized,
            refreshToken: "",
            email: "",
            musica_id: vm.music.post_uid,
            provider: "apple",
            upc: vm.upc,
            isrc: vm.isrc
          });
          vm.message = "Pre-save realizado!";
          vm.snackbar = true;
        }
      }
    };
  },
  computed: {
    currentURL() {
      return window.location.href;
    }
  },
  methods: {
    listHoldings() {
      const holdings = new Set();

      holdings.add(this.artista.artista_nome);
      for (const holder of this.holdings) {
        holdings.add(holder.artista_nome);
      }
      return Array.from(holdings).join(", ");
    },
    canLinkShow(type) {
      return !!this.platforms[type] || type === "custom";
    },
    getEmbedUrl(url) {
      const videoId = this.getYoutubeId(url);
      return (
        '<iframe width="100%" height="400px" src="//www.youtube.com/embed/' +
        videoId +
        '" allowfullscreen></iframe>'
      );
    },
    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    async copyUrl() {
      this.snackbar = false;
      const $url = $(location).attr("href");
      if (!navigator.clipboard) {
        const $temp = $("<input>");
        $("body").append($temp);
        $temp.val($url).select();
        document.execCommand("copy");
        $temp.remove();
      } else {
        await navigator.clipboard.writeText($url);
      }
      this.message = "URL Copiada";
      this.snackbar = true;
    },
    createPresave() {
      const vm = this;
      axios
        .post("/api/create/smartlink", {
          accessToken: vm.spotifyAuth
            ? vm.spotifyAuth.access_token
            : vm.deezerToken,
          refreshToken: vm.spotifyAuth ? vm.spotifyAuth.refreshToken : "",
          email: vm.me.email,
          musica_id: vm.music.post_uid,
          provider: vm.provider,
          upc: vm.upc,
          isrc: vm.isrc
        })
        .then(res => {
          vm.message = "Pre-save realizado!";
          vm.snackbar = true;
        });
    },
    async popup() {
      if (this.presave[this.selectedPresave]) {
        this.presave[this.selectedPresave]();
      }
    }
  },
  mounted() {
    let musicKit = document.createElement("script");
    musicKit.setAttribute(
      "src",
      "https://js-cdn.music.apple.com/musickit/v3/musickit.js"
    );
    document.head.appendChild(musicKit);

    const vm = this;
    window.localStorage.removeItem("music.p74ugf69tn.itre");
    window.localStorage.removeItem("music.p74ugf69tn.itua");
    window.localStorage.removeItem("music.p74ugf69tn.media-user-token");

    document.addEventListener("musickitloaded", function() {
      console.log("MusicKit global is now defined." + vm.appleToken);

      MusicKit.configure({
        developerToken: vm.appleToken,
        app: {
          name: "MusicPro",
          build: "1.0"
        }
      }).then(function(instance) {
        vm.instanceApple = MusicKit.getInstance();
      });
    });

    EventBus.$on("spotify", e => {
      console.log(e);
    });

    if (this.error) {
      this.message = "Ops, não foi possível realizar o pré-save";
      this.snackbar = true;
    }
    if ((this.spotifyAuth || this.deezerToken) && !this.error) {
      this.createPresave();
    }
  },
  watch: {
    accessToken(val) {
      console.log(val);
    },
    "spotifyCallback.accessToken": function(val) {
      console.log(val);
    }
  }
};
</script>

<style>
#smartBox {
  max-width: 450px;
}

@media (max-width: 390px) {
  .font {
    font-size: 10px;
  }
}

@media (min-width: 391px) and (max-width: 490px) {
  .font {
    font-size: 12px;
  }
}
</style>
